import { render, staticRenderFns } from "./lojaPerfeitaPillarModal.vue?vue&type=template&id=4c95d242&scoped=true&"
import script from "./lojaPerfeitaPillarModal.vue?vue&type=script&lang=js&"
export * from "./lojaPerfeitaPillarModal.vue?vue&type=script&lang=js&"
import style0 from "./lojaPerfeitaPillarModal.vue?vue&type=style&index=0&id=4c95d242&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c95d242",
  null
  
)

export default component.exports